import { useContext } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';

import {
  Box,
  Divider,
  Drawer,
  Typography,
  darken,
  styled,
  useTheme
} from '@mui/material';

import { useAppSelector } from 'src/hooks/redux';
import SidebarMenu from './SidebarMenu';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 68px;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();
  const { brand } = useAppSelector((state) => state.applications);

  return (
    <>
      <SidebarWrapper
        sx={{
          display: {
            xs: 'none',
            lg: 'inline-block'
          },
          position: 'fixed',
          left: 0,
          top: 0,
          background: brand.brand_color ?? darken(theme.colors.alpha.black[100], 0.5),
          // background:
          //   theme.palette.mode === 'dark'
          //     ? alpha(lighten(theme.header.background!, 0.1), 0.5)
          //     : darken(theme.colors.alpha.black[100], 0.5),
          boxShadow:
            theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none'
        }}
      >
        <Box mt={2.5} ml={2.5} display={'flex'} alignItems={'center'}>
          <img alt="brand logo" src={brand.logo} height={60} width={60} style={{ border: '2px solid white', borderRadius: '60px' }} />
          <Typography fontSize={'1.2rem'} ml={2} fontWeight={'800'} textTransform={'capitalize'} color='white'>Client Portal</Typography>
        </Box>
        <Divider
          sx={{
            mt: theme.spacing(2.5),
            mx: theme.spacing(2),
            background: theme.colors.alpha.trueWhite[10]
          }}
        />
        <Scrollbar>
          <SidebarMenu closeSidebar={closeSidebar} />
        </Scrollbar>
      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: `${theme.sidebar.boxShadow}`
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background: brand.brand_color ?? darken(theme.colors.alpha.black[100], 0.5),
          }}
        >
          <Box mt={2.5} ml={2.5}>
            <Typography fontSize={'1.2rem'} fontWeight={'800'} textTransform={'capitalize'} color='white'>Client Portal</Typography>
          </Box>
          <Divider
            sx={{
              mt: theme.spacing(2.5),
              mx: theme.spacing(2),
              background: theme.colors.alpha.trueWhite[10]
            }}
          />
          <Scrollbar>
            <SidebarMenu closeSidebar={closeSidebar} />
          </Scrollbar>
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
